export default "__VITE_ASSET__CqgpZI4A__"